import { NAME } from './constants';
import { router } from './router';

export const UzaverkaRozpracovanost = {
	name: NAME,
	router,
};
